import { FC, Fragment, useCallback, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import PoweredByBlazeIT from '../PoweredByBlazeIT';
import Demo from './Demo';

const useStyles = makeStyles((_theme) => ({
  title: {
    fontFamily: 'Helvetica',
    fontSize: '2rem',
  },
  text: {
    marginBottom: '1.5rem',
    maxWidth: 600,
    textAlign: 'center',
    margin: 'auto',
  },
  actionButton: {
    marginRight: '0.5rem',
  },

  buttonsWrapper: {
    marginTop: '1.2rem',
  },
}));

const Intro: FC<{
  onSchemaBuilder: () => void;
  livePreviewOn: boolean;
  setLivePreviewOn: (a: boolean) => void;
}> = ({ onSchemaBuilder, livePreviewOn, setLivePreviewOn }) => {
  useEffect(() => {
    const x = '&#64;';

    const m =
      '&#109;&#97;&#116;&#101;&#106;' +
      x +
      '&#98;&#108;&#97;&#122;&#101;&#105;&#116;&#46;&#115;&#107;';

    const msg =
      '&#67;&#111;&#110;&#116;&#97;&#99;&#116;&#32;&#109;&#101;&#32;&#97;&#116;&#32;&#109;&#121;&#32;&#101;&#109;&#97;&#105;&#108;';

    setTimeout(() => {
      const a = document.createElement('a');
      a.innerHTML = m;

      const q = a.innerHTML;

      a.innerHTML = msg;
      a.href = 'mailto:' + q;

      document.getElementById('mmm')?.append(a);
    }, 100);
  }, []);

  const classes = useStyles();

  return (
    <div className='main-container'>
      <div className='top-row'>
        <h1 className={classes.title}>Blaze Menu Builder</h1>
      </div>

      <div className='upper'>
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <Typography variant={'body1'} className={classes.text}>
            <strong>Blaze Menu Builder</strong> is a tool for creating Blaze
            Menus.
            <br />
            Created By Matej Murín, powered by{' '}
            <a href='https://blazeit.sk' style={{}} target='_blank'>
              blaze IT
            </a>
            .
          </Typography>

          {/* <Typography variant={'body1'} className={classes.text}>
            You can purchase the <strong>Blaze Menu</strong> on the{' '}
            <a href='TODO-marketplace' style={{}} target='_blank'>
              3D Vista Marketplace
            </a>
          </Typography> */}
        </div>

        <div className='preview-demo'>
          <label style={{}}>Blaze Menu preview:</label>
          <video
            muted
            autoPlay
            playsInline
            loop
            style={{
              marginTop: 4,
              width: 600,
              height: 'auto',
              maxWidth: '100%',
            }}
          >
            <source
              src={require('../assets/blaze-menu-preview.mp4').default}
              type='video/mp4'
            ></source>
          </video>
        </div>

        <div className='landing-buttons-wrapper'>
          <div>
            <Button
              className={classes.actionButton}
              onClick={() => setLivePreviewOn(true)}
              color='primary'
              variant='contained'
            >
              Show demo
            </Button>
          </div>
          {/* 
          <div>
            <Button
              className={classes.actionButton}
              onClick={onSchemaBuilder}
              color='primary'
              variant='contained'
            >
              Create Blaze Menu
            </Button>
          </div> */}

          <a
            href='https://market.3dvista.com/product/blaze-menu/'
            style={{ textDecoration: 'none', color: 'white' }}
            target='_blank'
          >
            <Button
              className={classes.actionButton}
              onClick={() => {}}
              color='primary'
              variant='contained'
            >
              Purchase on 3D Vista marketplace
            </Button>
          </a>
        </div>
      </div>

      <PoweredByBlazeIT color='black' isMain />

      {livePreviewOn && <Demo />}
    </div>
  );
};

export default Intro;
